import tw, { css } from 'twin.macro'

export const buttonStyles = css`
  button {
    ${tw`min-h-full w-full h-auto py-3 px-5 bg-transparent text-tertiary-5 [min-width: 19rem ] [max-width: 57rem ] text-footnote font-semibold uppercase border border-tertiary-3 hover:bg-transparent hover:border-tertiary-5 active:bg-tertiary-5 active:text-white focus:outline-none focus-visible:outline-primary-2`}
    p {
      ${tw`text-footnote`}
    }
    &[aria-expanded='true'] {
      ${tw`bg-tertiary-5 text-white`}
      svg {
        ${tw`rotate-180`}
      }
    }
    &:disabled {
      ${tw`opacity-30 bg-white border-tertiary-3`}
    }
    span {
      ${tw`w-full`}
      div {
        ${tw`w-full m-auto`}
      }
      svg {
        ${tw`transition transform ml-auto`}
      }
    }
  }
`

export const getPopoverStyles = () => css`
  ul[role='listbox'] {
    ${tw`mt-2 rounded-3xl w-full h-auto p-12 bg-tertiary-5 text-white [min-width: 19rem ] [max-width: 57rem ]`}
    li[role="presentation"] > span {
      ${tw`font-bold text-footnote font-body`}
    }
    li:not([role='presentation']) {
      ${tw`px-0 mb-2.5 transition hover:text-gray-300 hover:bg-transparent active:text-gray-300 active:bg-transparent hover:cursor-pointer`}
    }

    ul[role='group'] {
      ${tw`p-0 mt-4`}
    }
  }
`
